import Vue from 'vue'
import numeral from '@/plugin/CustomNumeral'

export const filterUnits = function (value) {
  return numeral(value).format('0,00 a')
}

export const filterUnitsExtended = function (value) {
  return numeral(value).format('0,00')
}

export const filterPesos = function (value) {
  return numeral(value).format('$0,00 a')
}

export const filterPesosExtended = function (value) {
  return numeral(value).format('$0,00')
}

Vue.filter('money', function (value) {
  return numeral(value).format('$ 0.00 a')
})

Vue.filter('number', function (value) {
  return numeral(value).format('0,0')
})

Vue.filter('numberAbb', function (value) {
  return numeral(value).format('0.0a')
})

Vue.filter('percentage', function (value) {
  return numeral(value).format('0%')
})

Vue.filter('decimalMoney', function (value) {
  return numeral(value).format('$0,00')
})

Vue.filter('numberFormat', function (value, formatType) {
  if (formatType === 'PESOS') {
    return numeral(value).format('$0,00 a')
  } else if (formatType === 'UNITS') {
    return numeral(value).format(' 0')
  }
})

Vue.filter('units', filterUnits)

Vue.filter('pesos', filterPesos)

Vue.filter('pesos_extended', filterPesosExtended)

Vue.filter('units_extended', filterUnitsExtended)



// WEBPACK FOOTER //
// ./src/utils/Filters.js